import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import { IAbsenceWarningRepository } from 'shared/domain/repositories';
import { AbsenceWarning, IVectisAbsenceWarning } from 'shared/infra/adapters';

export default class VectisAbsenceWarningRepository
  implements IAbsenceWarningRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public evaluate: IAbsenceWarningRepository['evaluate'] = async ({
    customerId,
    scheduleId,
  }) => {
    const response = await this.httpProvider.get<IVectisAbsenceWarning>(
      'agendas/aviso-falta-cancelamento',
      {
        params: {
          id_cliente: customerId,
          id_agenda: scheduleId,
        },
      },
    );

    return new AbsenceWarning(response);
  };

  public confirm: IAbsenceWarningRepository['confirm'] = async ({
    customerId,
    moment,
    channel,
    flow,
    scheduleId,
  }) => {
    await this.httpProvider.post(
      `agendas/aviso-falta-cancelamento/${customerId}/confirmar`,
      {
        momento: moment,
        canal: channel,
        fluxo: flow,
        idAgenda: scheduleId,
      },
    );
  };
}
